import submitFhirJson from "../../functions/submitFhirJsonAPI";
import { editModeOn } from "../../slices/editMode/editModeSlice";
import { globalLoadingOff, globalLoadingOn } from "../../slices/globalLoading/globalLoadingSlice";
import { changeFoiFocus } from "../../slices/foiOfFocus/foiOfFocusSlice";

const submitResource = async (fhirEntry, apiToken, navigate, dispatch, pubStatus) => {
    
    dispatch(globalLoadingOn());
    let fhirJson;
    try {
        if (fhirEntry) {
            if (typeof fhirEntry === "string") {
                fhirJson = JSON.parse(fhirEntry);
            } else {
                fhirJson = fhirEntry;
            }
        } else {
            alert("No JSON");
            dispatch(globalLoadingOff());
            return;
        }
    } catch {
        alert("Invalid JSON");
        dispatch(globalLoadingOff());
        return;
    }
    //Warnings if the JSON is missing a resourceType or title field
    if (!("resourceType" in fhirJson) || fhirJson.resourceType.trim() === "") {
        alert("resourceType field is missing from JSON.");
        dispatch(globalLoadingOff());
        return;
    }

    let title = "";
    if (fhirJson.title && typeof fhirJson.title === "string" && fhirJson.title.trim()) {
        title = fhirJson.title;
    } else if (fhirJson.name) {
        if (typeof fhirJson.name === "string" && fhirJson.name.trim()) {
            title = fhirJson.name;
        } else if (Array.isArray(fhirJson.name) && fhirJson.name.length > 0 && fhirJson.name[0].text && fhirJson.name[0].text.trim() !== "") {
            title = fhirJson.name[0].text;
        }
    }

    const submitTheResource = async () => {
        let response = await submitFhirJson(fhirJson, title, apiToken, pubStatus);
        if (response?.success) {
            //navigate("/");
            dispatch(changeFoiFocus(response.formstateid.toString()));
            navigate(`/resources/${response.resourcetype}/${response.formstateid}/edit`, { replace: true });
            dispatch(editModeOn());
        } else {
            alert("Problem submitting to server.")
        }
    }

    if (title) {
        await submitTheResource();
        dispatch(globalLoadingOff());
    } else {
        alert("title or name field is missing from JSON");
        dispatch(globalLoadingOff());
    }
};

export default submitResource;